import { render, staticRenderFns } from "./ReadingDup.vue?vue&type=template&id=0ecbce34&scoped=true&"
import script from "./ReadingDup.vue?vue&type=script&lang=js&"
export * from "./ReadingDup.vue?vue&type=script&lang=js&"
import style0 from "./ReadingDup.vue?vue&type=style&index=0&id=0ecbce34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecbce34",
  null
  
)

export default component.exports